<template>
    <div class="vant-field-acb">
        <van-field @click="showFieldChoice" :label="label" :required="required" :readonly="true" v-model="text"
                   :placeholder="placeholder"  :style="cellStyle"/>
        <van-popup v-model="showPop" position="bottom">
            <van-nav-bar :title="label" left-text="取消" right-text="确认" @click-left="onCancel"
                         @click-right="onConfirm"/>
            <van-search placeholder="请输入搜索关键词" v-model="keywords" />
            <van-list @load="onLoad" :finished="finished" id="list" :loading="loading" finished-text="没有更多了">
                <van-checkbox-group v-model="checkedNames">
                    <van-cell-group>
                        <van-cell v-for="(column, index) in columns" :key="column.value" :title="column.text"
                                  @click="onSelect(index)" :clickable="multiple">
                            <van-checkbox :name="column.value" v-if="multiple" ref="checkboxes" slot="right-icon"/>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </van-list>
        </van-popup>
    </div>
</template>
<script>
    import {Field, List, Cell, Popup, NavBar, Search, Checkbox, CellGroup, CheckboxGroup} from 'vant';
    import dictionaryService from "../service/dictionaryService";

    export default {
        name: 'VanFieldAcb',
        components: {
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Checkbox.name]: Checkbox,
            [CellGroup.name]: CellGroup,
            [CheckboxGroup.name]: CheckboxGroup,
            [Popup.name]: Popup
        },
        data() {
            return {
                columns: [],
                text: null,
                keywords: '',
                pageIndex: 0,
                showPop: false,
                finished: false,
                loading: false,
                checkedNames: []
            }
        },
        props: {
            label: {
                type: String,
                default: null
            },
            value: {
                type: String,
                default: null
            },
            dict: {
                type: String,
                default: null
            },
            filter: {
                type: String,
                default: ''
            },
            pageSize: {
                type: Number,
                default: 5
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: '请选择'
            },
            multiple: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default: null
            },
            onChange: {
                type: String,
                default: null
            },
            cellStyle: {
                type: Object,
                default: null
            }
        },
        methods: {
            showFieldChoice(){
                if(!this.readonly){
                    this.showPop = true;
                }
            },
            onCancel() {
                this.showPop = false;
                if(this.multiple && this.value!=null && this.value!=undefined && this.value!=""){
                    this.checkedNames=this.value.split(",");
                }
            },
            onConfirm() {
                this.showPop = false;
                this.$emit('input', "0");
                this.$emit('input', this.checkedNames.join(','));
                if (this.onChange) {
                    eval(this.onChange);
                }
            },
            onSelect(index) {
                if (!this.multiple) {
                    this.showPop = false;
                    this.$emit('input', this.columns[index].value);
                    if (this.onChange) {
                        eval(this.onChange);
                    }
                } else {
                    this.$refs.checkboxes[index].toggle();
                }
            },
            async onLoad() {
                this.loading = true;
                if (this.options) {
                    this.finished = true;
                    this.columns = this.options.map(item => {
                        return {text: item.text, value: item.id};
                    });
                    this.loading = false;
                } else {
                    this.pageIndex++;
                    let dictionaryName = this.dict;
                    let colName = "";
                    if (this.dict.indexOf(".")){
                        dictionaryName = this.dict.split(".")[0];
                        colName = this.dict.split(".")[1];
                    }
                    let resp = await dictionaryService.getOptions(dictionaryName, this.pageIndex, this.pageSize, this.filter,
                        this.keywords,colName);
                    this.loading = false;
                    if (resp.data.Status === "1") {
                        this.finished = resp.data.Data.length < this.pageSize;
                        resp.data.Data.forEach(acb => {
                            this.columns.push({text: acb.name, value: acb.uuid});
                        });
                    }
                }
            },
            async getText() {
                let value = this.value;
                let texts = [];
                if (this.options) {
					if(value!=null && value!=undefined && value!=""){
						 value.split(",").forEach(item => {
						    let dict = this.options.find(dict => dict.id === item);
						    if (dict) texts.push(dict.text);
						});
					}
                   
                } else {
                    let dictionaryName = this.dict;
                    let colName = "";
                    if (this.dict.indexOf(".")){
                        dictionaryName = this.dict.split(".")[0];
                        colName = this.dict.split(".")[1];
                    }
                    let resp = await dictionaryService.getText(dictionaryName, value ,colName);
                    if (resp.data.Status === "1") {
						if(value!=null && value!=undefined && value!=""){
							value.split(",").forEach(item => {
								let dict = resp.data.Data.find(dict => dict.uuid === item);
								if (dict) texts.push(dict.name);
							});
						}
                    }
                }
                this.text = texts.join(',');
            }
        },
        watch: {
            keywords() {
                this.pageIndex = 0;
                this.columns = [];
                this.onLoad();
            },
            async value() {
                if (this.options) {
                    this.text = this.options.filter(op => this.checkedNames.indexOf(op.id) >= 0)
                        .map(op => op.text).join(',');
                } else {
                    this.getText();
                }
            },
            options() {
                this.columns = this.options.map(item => {
                    return {text: item.text, value: item.id};
                });
            }
        },
        mounted: function () {
            if(this.multiple && this.value!=null && this.value!=undefined && this.value!=""){
                this.checkedNames=this.value.split(",");
            }
            this.getText();
        },
        computed: {}
    }
</script>
<style>
    #list {
        height: 20rem;
        overflow: auto;
    }
    .vant-field-acb>.van-cell>.van-cell__title {
        text-align: right;
        margin-right:1rem;
    }
    .vant-field-acb>.van-cell--required::before {
        left: 107px;
        top: 13px;
    }
</style>